var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-item"},[_c('van-loading',{attrs:{"color":"#fff"}}),_vm._v(" "+_vm._s(_vm.tisp)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }